export class SetGiftID {
  static readonly type = '[Gift] Set Gift ID';
  constructor(public payload: string) {}
}
export class SetGiftExtra {
  static readonly type = '[Gift] Set Gift Extra';
  constructor(public payload: string) {}
}
export class SetGiftCompleted {
  static readonly type = '[Gift] Set Gift Completed';
  constructor(public payload: boolean) {}
}
